import React, { lazy, Suspense } from 'react'
import { Helmet } from 'react-helmet'
import { Route } from 'react-router-dom'

import { SimpleLoader } from '../../components'

const BookingPage = lazy(() => import('./BookingPage'))
const EditBookingAsHost = lazy(() => import('./EditBookingAsHost'))
const CustomPayment = lazy(() => import('./components/CustomPayment'))
const BookingDetails = lazy(() => import('./BookingDetails'))

export const Booking: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Kiss & Tell - Booking</title>
        <meta
          name="description"
          content="Book your room or package for the event and secure your spot now! Get all the details about your booking and save your flight details."
        />
      </Helmet>

      <Route
        exact
        path="/booking/:bookingId"
        render={() => (
          <Suspense fallback={<SimpleLoader />}>
            <BookingPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/booking/:bookingId/payment"
        render={() => (
          <Suspense fallback={<SimpleLoader />}>
            <CustomPayment />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/booking/:bookingId/details"
        render={() => (
          <Suspense fallback={<SimpleLoader />}>
            <BookingDetails />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/booking/:bookingId/edit"
        render={() => (
          <Suspense fallback={<SimpleLoader />}>
            <EditBookingAsHost />
          </Suspense>
        )}
      />
    </>
  )
}
